

// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   FormControlLabel,
//   Checkbox,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { Visibility, Edit } from "@mui/icons-material";
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   maxHeight: "90vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   display: "flex",
//   flexDirection: "column",
//   outline: "none",
// };

// export default function ClaimCANSttldList() {
//   const [originalRows, setOriginalRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // Filter state
//   const [feFilter, setFeFilter] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   const [readOnlyData, setReadOnlyData] = useState({
//     ver2_assesment_amt: "",
//     ver_2_remarks: "",
//     ca_assesment_amt: "",
//     ca_remark: "",
//     is_ca_verified: false,
//   });

//   const [editableSettlFields, setEditableSettlFields] = useState({
//     settle_id: "",
//     settl_amt: "",
//     sttl_remarks: "",
//     is_settled: false,
//   });

//   const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal"; // default
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ca-sttl-claims-mgmt/`);
//       const data = res.data.map((item, idx) => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
//         const csm = Array.isArray(item.claim_settl_master) ? item.claim_settl_master[0] : null;
//         const status = csb
//           ? csb.is_rejected
//             ? "Rejected"
//             : csb.is_ca_verified
//             ? "CA Verified"
//             : csb.is_verified_2 || csb.is_verified_1
//             ? "In Progress"
//             : csb.is_submited
//             ? "Submitted"
//             : "Draft"
//           : "Unknown";

//         return {
//           id: item.id,
//           slNo: idx + 1,
//           claimant_name: item.name_of_claimant1 || "-",
//           ack_no: item.ack_no || "-",
//           fe_name: item.fe_name || "-",
//           application_type: getApplicationType(item.is_normal, item.is_delayed),
//           created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
//           status,
//           fullData: item,
//           settle_id: csm?.settle_id || "",
//           settl_amt: csm?.settl_amt || "",
//           sttl_remarks: csm?.sttl_remarks || "",
//           is_settled: csb?.is_settled || false,
//         };
//       });
      
//       // Store original data
//       setOriginalRows(data);
      
//       // Extract unique FE names for filter dropdown
//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
      
//     } catch {
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchClaims(); }, []);

//   // Apply filter to get current rows
//   const applyFilter = () => {
//     if (feFilter === "all") {
//       return originalRows;
//     } else {
//       return originalRows.filter(row => row.fe_name === feFilter);
//     }
//   };

//   const rows = applyFilter();

//   const handleFeFilterChange = (event) => {
//     setFeFilter(event.target.value);
//   };

//   const handleEditClick = (id) => {
//     const claim = originalRows.find(r => r.id === id);
//     if (!claim) return;

//     const totalObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ver2_assesment_amt: "-", total_claim: "-", is_claim_amt_mached: null };

//     const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ver_2_remarks: "-" };

//     const caTotalObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ca_assesment_amt: "-" };

//     const caRemarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ca_remark: "-" };

//     const csb = claim.fullData.claim_status_base && claim.fullData.claim_status_base[0]
//       ? claim.fullData.claim_status_base[0]
//       : { is_ca_verified: false };

//     setReadOnlyData({
//       ver2_assesment_amt: totalObj.ver2_assesment_amt,
//       ver_2_remarks: remarkObj.ver_2_remarks,
//       ca_assesment_amt: caTotalObj.ca_assesment_amt,
//       ca_remark: caRemarkObj.ca_remark,
//       is_ca_verified: csb.is_ca_verified,
//     });

//     setEditableSettlFields({
//       settle_id: claim.settle_id,
//       settl_amt: claim.settl_amt,
//       sttl_remarks: claim.sttl_remarks,
//       is_settled: claim.is_settled,
//     });

//     setShowEditModal(true);
//     setSelectedClaimId(id);
//   };

//   const handleViewClick = (id) => {
//     setSelectedClaimId(id);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//   };

//   const handleBackToClaims = () => {
//     setSelectedClaimId(null);
//   };

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
    
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },

//     {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     // {
//     //   id: "status",
//     //   field: "status",
//     //   headerName: "Status",
//     //   width: 140,
//     //   renderCell: (params) => (
//     //     <Chip
//     //       label={params.value}
//     //       color={
//     //         params.value === "Rejected"
//     //           ? "error"
//     //           : params.value === "CA Verified"
//     //           ? "success"
//     //           : params.value === "In Progress"
//     //           ? "warning"
//     //           : params.value === "Submitted"
//     //           ? "info"
//     //           : "default"
//     //       }
//     //       variant="outlined"
//     //       size="small"
//     //     />
//     //   ),
//     // },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
//             <Visibility />
//           </IconButton>
//           <IconButton color="secondary" onClick={() => handleEditClick(params.row.id)} title="Edit Claim">
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditableSettlFields((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleEditSubmit = async () => {
//     try {
//       await api.patch(`/claim-mgmt/ca-sttl-claims-mgmt/${selectedClaimId}/`, {
//         settle_id: editableSettlFields.settle_id,
//         settl_amt: editableSettlFields.settl_amt,
//         sttl_remarks: editableSettlFields.sttl_remarks,
//         is_settled: editableSettlFields.is_settled,
//       });
//       showSnackbar("Claim settlement updated successfully", "success");
//       setShowEditModal(false);
//       // Refresh the entire table data
//       await fetchClaims();
//     } catch {
//       showSnackbar("Failed to update claim", "error");
//     }
//   };

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"ca-sttl-claims-mgmt"}/>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" mb={2}>Claims Settlement Management</Typography>

//       {/* FE Filter Section */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-label"
//             value={feFilter}
//             label="Select FE"
//             onChange={handleFeFilterChange}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={fe} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilter !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilter}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilter("all")}
//           />
//         )}
//       </Box>

//       {loading ? <LoadingSpinner /> : <TableComponent rows={rows} columns={columns} />}

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />

//       <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
//         <Box
//           sx={{
//             ...style,
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           {/* Header */}
//           <Typography id="edit-claim-modal-title" variant="h6" p={2} borderBottom="1px solid #ccc">
//             Edit Claim Settlement Details
//           </Typography>

//           {/* Scrollable content */}
//           <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
//             <Stack spacing={2}>
//               <TextField label="Verifier 2 Assessment Amount" value={readOnlyData.ver2_assesment_amt} InputProps={{ readOnly: true }} fullWidth />
//               <TextField label="Verifier 2 Remarks" value={readOnlyData.ver_2_remarks} InputProps={{ readOnly: true }} multiline minRows={3} fullWidth />
//               <TextField label="CA Assessment Amount" value={readOnlyData.ca_assesment_amt} InputProps={{ readOnly: true }} fullWidth />
//               <TextField label="CA Remarks" value={readOnlyData.ca_remark} InputProps={{ readOnly: true }} multiline minRows={3} fullWidth />
//               <Box display="flex" alignItems="center">
//                 <input type="checkbox" checked={readOnlyData.is_ca_verified} readOnly style={{ pointerEvents: "none" }} />
//                 <label style={{ marginLeft: 8 }}>Verified CA</label>
//               </Box>

//               <TextField label="Settlement ID" name="settle_id" value={editableSettlFields.settle_id} onChange={handleInputChange} fullWidth />
//               <TextField label="Settlement Amount" name="settl_amt" value={editableSettlFields.settl_amt} onChange={handleInputChange} fullWidth />
//               <TextField label="Settlement Remarks" name="sttl_remarks" value={editableSettlFields.sttl_remarks} onChange={handleInputChange} multiline minRows={3} fullWidth />
//               <FormControlLabel
//                 control={<Checkbox checked={editableSettlFields.is_settled} onChange={handleInputChange} name="is_settled" />}
//                 label="Is Settled"
//               />
//             </Stack>
//           </Box>

//           {/* Footer */}
//           <Box sx={{ p: 2, borderTop: "1px solid #ccc", display: "flex", justifyContent: "flex-end", gap: 1 }}>
//             <Button variant="contained" onClick={handleEditSubmit}>Save</Button>
//             <Button variant="outlined" onClick={handleCloseEditModal}>Cancel</Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }

// pre final without amount validation
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { Visibility, Edit } from "@mui/icons-material";
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   maxHeight: "90vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   display: "flex",
//   flexDirection: "column",
//   outline: "none",
// };

// export default function ClaimCANSttldList() {
//   const [originalRows, setOriginalRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // Filter state
//   const [feFilter, setFeFilter] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   // Read-only data for display
//   const [readOnlyData, setReadOnlyData] = useState({
//     ver2_assesment_amt: "",
//     ver_2_remarks: "",
//     ca_assesment_amt: "",
//     ca_remark: "",
//   });

//   const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal";
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ca-sttl-claims-mgmt/`);
//       const data = res.data.map((item, idx) => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
//         const csm = Array.isArray(item.claim_settl_master) ? item.claim_settl_master[0] : null;
//         const status = csb
//           ? csb.is_rejected
//             ? "Rejected"
//             : csb.is_ca_verified
//             ? "CA Verified"
//             : csb.is_verified_2 || csb.is_verified_1
//             ? "In Progress"
//             : csb.is_submited
//             ? "Submitted"
//             : "Draft"
//           : "Unknown";

//         return {
//           id: item.id,
//           slNo: idx + 1,
//           claimant_name: item.name_of_claimant1 || "-",
//           ack_no: item.ack_no || "-",
//           fe_name: item.fe_name || "-",
//           application_type: getApplicationType(item.is_normal, item.is_delayed),
//           created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
//           status,
//           fullData: item,
//           settle_id: csm?.settle_id || "",
//           settl_amt: csm?.settl_amt || "",
//           sttl_remarks: csm?.sttl_remarks || "",
//           is_settled: csb?.is_settled || false,
//         };
//       });

//       setOriginalRows(data);
//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
//     } catch {
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchClaims(); }, []);

//   const applyFilter = () => {
//     if (feFilter === "all") {
//       return originalRows;
//     } else {
//       return originalRows.filter(row => row.fe_name === feFilter);
//     }
//   };

//   const rows = applyFilter();

//   const handleFeFilterChange = (event) => {
//     setFeFilter(event.target.value);
//   };

//   // Formik with validation - FIXED FORM ID
//   const formik = useFormik({
//     initialValues: {
//       settle_id: '',
//       settl_amt: '',
//       sttl_remarks: '',
//     },
//     validationSchema: Yup.object({
//       settle_id: Yup.string().required('Settlement ID is required'),
//       settl_amt: Yup.number()
//         .typeError('Must be a number')
//         .positive('Must be greater than 0')
//         .required('Settlement amount is required'),
//     }),
//     onSubmit: async (values) => {
//       try {
//         await api.patch(`/claim-mgmt/ca-sttl-claims-mgmt/${selectedClaimId}/`, {
//           settle_id: values.settle_id,
//           settl_amt: values.settl_amt,
//           sttl_remarks: values.sttl_remarks,
//           is_settled: true, // Always true when settling
//         });
//         showSnackbar("Claim settled successfully", "success");
//         handleCloseEditModal();
//         await fetchClaims();
//       } catch {
//         showSnackbar("Failed to settle claim", "error");
//       }
//     },
//   });

//   const handleViewClick = (id) => {
//     setSelectedClaimId(id);
//   };

//   const handleEditClick = (id) => {
//     const claim = originalRows.find(r => r.id === id);
//     if (!claim) return;

//     const totalObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ver2_assesment_amt: "-", total_claim: "-", ca_assesment_amt: "-" };

//     const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ver_2_remarks: "-", ca_remark: "-" };

//     setReadOnlyData({
//       ver2_assesment_amt: totalObj.ver2_assesment_amt || "-",
//       ver_2_remarks: remarkObj.ver_2_remarks || "-",
//       ca_assesment_amt: totalObj.ca_assesment_amt || "-",
//       ca_remark: remarkObj.ca_remark || "-",
//     });

//     // Load formik values
//     const csm = Array.isArray(claim.fullData.claim_settl_master) ? claim.fullData.claim_settl_master[0] : null;
//     formik.setValues({
//       settle_id: csm?.settle_id || '',
//       settl_amt: csm?.settl_amt || '',
//       sttl_remarks: csm?.sttl_remarks || '',
//     });

//     setShowEditModal(true);
//     setSelectedClaimId(id);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedClaimId(null);
//     formik.resetForm();
//   };

//   const handleBackToClaims = () => {
//     setSelectedClaimId(null);
//   };

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },
//     {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
//             <Visibility />
//           </IconButton>
//           <IconButton color="secondary" onClick={() => handleEditClick(params.row.id)} title="Settle Claim">
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"ca-sttl-claims-mgmt"}/>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" mb={2}>Claims Settlement Management</Typography>

//       {/* FE Filter Section */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-label"
//             value={feFilter}
//             label="Select FE"
//             onChange={handleFeFilterChange}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={fe} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilter !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilter}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilter("all")}
//           />
//         )}
//       </Box>

//       {loading ? <LoadingSpinner /> : <TableComponent rows={rows} columns={columns} />}

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />

//       <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
//         <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
//           {/* Header */}
//           <Typography id="edit-claim-modal-title" variant="h6" p={2} borderBottom="1px solid #ccc">
//             Settle Claim
//           </Typography>

//           {/* Scrollable content */}
//           <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
//             {/* ✅ FIXED: Added proper form with id */}
//             <form id="settle-form" onSubmit={formik.handleSubmit} noValidate>
//               <Stack spacing={2}>
//                 {/* Read-only fields with title/description format */}
//                 <Box>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     Verifier 2 Assessment Amount
//                   </Typography>
//                   <Typography variant="body1">{readOnlyData.ver2_assesment_amt || "-"}</Typography>
//                 </Box>

//                 <Box>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     Verifier 2 Remarks
//                   </Typography>
//                   <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
//                     {readOnlyData.ver_2_remarks || "-"}
//                   </Typography>
//                 </Box>

//                 <Box>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     CA Assessment Amount
//                   </Typography>
//                   <Typography variant="body1">{readOnlyData.ca_assesment_amt || "-"}</Typography>
//                 </Box>

//                 <Box>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     CA Remarks
//                   </Typography>
//                   <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
//                     {readOnlyData.ca_remark || "-"}
//                   </Typography>
//                 </Box>

//                 {/* Editable settlement fields with validation */}
//                 <TextField
//                   label="Settlement ID *"
//                   name="settle_id"
//                   value={formik.values.settle_id}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   fullWidth
//                   error={formik.touched.settle_id && Boolean(formik.errors.settle_id)}
//                   helperText={formik.touched.settle_id && formik.errors.settle_id}
//                 />

//                 <TextField
//                   label="Settlement Amount *"
//                   name="settl_amt"
//                   type="number"
//                   value={formik.values.settl_amt}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   fullWidth
//                   error={formik.touched.settl_amt && Boolean(formik.errors.settl_amt)}
//                   helperText={formik.touched.settl_amt && formik.errors.settl_amt}
//                   inputProps={{ step: '0.01', min: '0' }}
//                 />

//                 <TextField
//                   label="Settlement Remarks"
//                   name="sttl_remarks"
//                   multiline
//                   minRows={3}
//                   value={formik.values.sttl_remarks}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   fullWidth
//                 />
//               </Stack>
//             </form>
//           </Box>

//           {/* Footer - ✅ FIXED: Button inside form */}
//           <Box sx={{ p: 2, borderTop: "1px solid #ccc", display: "flex", justifyContent: "flex-end", gap: 1 }}>
//             <Button 
//               type="submit" 
//               form="settle-form"
//               variant="contained" 
//               disabled={formik.isSubmitting || !formik.isValid}
//             >
//               Settle Claim
//             </Button>
//             <Button 
//               type="button"
//               variant="outlined" 
//               onClick={handleCloseEditModal} 
//               disabled={formik.isSubmitting}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }


// final with amount validation
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Chip,
  Modal,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Visibility, Edit } from "@mui/icons-material";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from "../../../api/axiosInterceptor";
import { API_BASE_URL } from "../../../config";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { LoadingSpinner } from "../../../Components/spinner/spinner";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
import ClaimDetailPage from "../claimView";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",
};

export default function ClaimCANSttldList() {
  const [originalRows, setOriginalRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  // Filter state
  const [feFilter, setFeFilter] = useState("all");
  const [uniqueFEs, setUniqueFEs] = useState([]);

  // Read-only data for display
  const [readOnlyData, setReadOnlyData] = useState({
    total_claim: "",
    ver2_assesment_amt: "",
    ver_2_remarks: "",
    ca_assesment_amt: "",
    ca_remark: "",
  });

  // ✅ Store CA verified amount for validation
  const [caVerifiedAmount, setCaVerifiedAmount] = useState(0);

  const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const getApplicationType = (isNormal, isDelayed) => {
    if (isNormal) return "Normal";
    if (isDelayed) return "Delayed";
    return "Normal";
  };

  const fetchClaims = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/claim-mgmt/ca-sttl-claims-mgmt/`);
      const data = res.data.map((item, idx) => {
        const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
        const csm = Array.isArray(item.claim_settl_master) ? item.claim_settl_master[0] : null;
        const status = csb
         ? csb.is_rejected
           ? "Rejected"
           : csb.is_ca_verified
           ? "CA Verified"
           : csb.is_verified_2 || csb.is_verified_1
           ? "In Progress"
           : csb.is_submited
           ? "Submitted"
           : "Draft"
         : "Unknown";

        return {
          id: item.id,
          slNo: idx + 1,
          // claimant_name: item.name_of_claimant1 || "-",
          claimant_name:
              item.claiment_type === "self"
                ? item.name_of_claimant1 || "-"
                : item.claiment_type === "nominee"
                ? item.nominee?.[0]?.name || "-"
                : item.claiment_type === "legal_heir"
                ? item.legalHeir?.[0]?.name || "-"
                : item.name_of_claimant1 || "-",
          ack_no: item.ack_no || "-",
          fe_name: item.fe_name || "-",
          application_type: getApplicationType(item.is_normal, item.is_delayed),
          created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
          status,
          fullData: item,
          settle_id: csm?.settle_id || "",
          settl_amt: csm?.settl_amt || "",
          sttl_remarks: csm?.sttl_remarks || "",
          is_settled: csb?.is_settled || false,
        };
      });

      setOriginalRows(data);
      const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
      setUniqueFEs(feNames);
    } catch {
      showSnackbar("Failed to load claims", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchClaims(); }, []);

  const applyFilter = () => {
    if (feFilter === "all") {
      return originalRows;
    } else {
      return originalRows.filter(row => row.fe_name === feFilter);
    }
  };

  const rows = applyFilter();

  const handleFeFilterChange = (event) => {
    setFeFilter(event.target.value);
  };

  // ✅ CUSTOM VALIDATION FUNCTION - Settlement cannot exceed CA verified amount
  const validateForm = useCallback((values) => {
    const errors = {};
    
    if (!values.settle_id || values.settle_id.trim() === "") {
      errors.settle_id = 'Settlement ID is required';
    }
    
    if (values.settl_amt) {
      const settlementAmt = parseFloat(values.settl_amt);
      if (isNaN(settlementAmt)) {
        errors.settl_amt = 'Must be a number';
      } else if (settlementAmt <= 0) {
        errors.settl_amt = 'Must be greater than 0';
      } else if (settlementAmt > caVerifiedAmount) {
        errors.settl_amt = `Cannot exceed CA verified amount (₹${caVerifiedAmount.toLocaleString()})`;
      }
    }

    return errors;
  }, [caVerifiedAmount]);

  // Formik - using custom validate function
  const formik = useFormik({
    initialValues: {
      settle_id: '',
      settl_amt: '',
      sttl_remarks: '',
    },
    validate: validateForm,
    onSubmit: async (values) => {
      try {
        await api.patch(`/claim-mgmt/ca-sttl-claims-mgmt/${selectedClaimId}/`, {
          settle_id: values.settle_id,
          settl_amt: values.settl_amt,
          sttl_remarks: values.sttl_remarks,
          is_settled: true, // Always true when settling
        });
        showSnackbar("Claim settled successfully", "success");
        handleCloseEditModal();
        await fetchClaims();
      } catch {
        showSnackbar("Failed to settle claim", "error");
      }
    },
  });

  const handleViewClick = (id) => {
    setSelectedClaimId(id);
  };

  const handleEditClick = (id) => {
    const claim = originalRows.find(r => r.id === id);
    if (!claim) return;

    const totalObj = claim.fullData.total && claim.fullData.total[0]
      ? claim.fullData.total[0]
      : { ver2_assesment_amt: "-", total_claim: "-", ca_assesment_amt: "-" };

    const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
      ? claim.fullData.claim_rem_base[0]
      : { ver_2_remarks: "-", ca_remark: "-" };

    // ✅ Set CA verified amount from API data
    const parsedCaAmount = parseFloat(totalObj.ca_assesment_amt) || 0;
    setCaVerifiedAmount(parsedCaAmount);

    setReadOnlyData({
      total_claim: totalObj.total_claim || "-",        // ✅ Added claimed amount
      ver2_assesment_amt: totalObj.ver2_assesment_amt || "-",
      ver_2_remarks: remarkObj.ver_2_remarks || "-",
      ca_assesment_amt: totalObj.ca_assesment_amt || "-",
      ca_remark: remarkObj.ca_remark || "-",
    });

    // Load formik values
    const csm = Array.isArray(claim.fullData.claim_settl_master) ? claim.fullData.claim_settl_master[0] : null;
    formik.setValues({
      settle_id: csm?.settle_id || '',
      settl_amt: csm?.settl_amt || '',
      sttl_remarks: csm?.sttl_remarks || '',
    });

    // Re-run validation with new CA amount
    formik.validateForm();

    setShowEditModal(true);
    setSelectedClaimId(id);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedClaimId(null);
    setCaVerifiedAmount(0); // Reset CA verified amount
    formik.resetForm();
  };

  const handleBackToClaims = () => {
    setSelectedClaimId(null);
  };

  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
    { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
    { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
    { id: "created", field: "created", headerName: "Applied Date", width: 150 },
    {
      id: "application_type",
      field: "application_type",
      headerName: "Application Type",
      width: 140,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "Normal" ? "success" : "warning"}
          variant="outlined"
          size="small"
        />
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 140,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
            <Visibility />
          </IconButton>
          <IconButton color="secondary" onClick={() => handleEditClick(params.row.id)} title="Settle Claim">
            <Edit />
          </IconButton>
        </>
      ),
    },
  ];

  if (selectedClaimId && !showEditModal) {
    return (
      <Box sx={{ p: 3 }}>
        <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
          Back to Claims
        </Button>
        <ClaimDetailPage pk={selectedClaimId} claim_url={"ca-sttl-claims-mgmt"}/>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" mb={2}>Claims Settlement Management</Typography>

      {/* FE Filter Section */}
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body1" fontWeight="medium">
          Filter by FE:
        </Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="fe-filter-label">Select FE</InputLabel>
          <Select
            labelId="fe-filter-label"
            value={feFilter}
            label="Select FE"
            onChange={handleFeFilterChange}
            size="small"
          >
            <MenuItem value="all">All FEs</MenuItem>
            {uniqueFEs.map((fe) => (
              <MenuItem key={fe} value={fe}>
                {fe}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {feFilter !== "all" && (
          <Chip 
            label={`Showing: ${feFilter}`} 
            color="primary" 
            variant="outlined"
            onDelete={() => setFeFilter("all")}
          />
        )}
      </Box>

      {loading ? <LoadingSpinner /> : <TableComponent rows={rows} columns={columns} />}

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />

      <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
        <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <Typography id="edit-claim-modal-title" variant="h6" p={2} borderBottom="1px solid #ccc">
            Settle Claim
          </Typography>

          {/* Scrollable content */}
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            <form id="settle-form" onSubmit={formik.handleSubmit} noValidate>
              <Stack spacing={2}>
                {/* ✅ ADDED: Claimed Amount (read-only) - FIRST POSITION */}
                <Box>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    Total Claim Amount
                  </Typography>
                  <Typography variant="body1">
                    ₹{readOnlyData.total_claim || "-"}
                  </Typography>
                </Box>

                {/* Read-only fields with title/description format */}
                <Box>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    Verifier 2 Assessment Amount
                  </Typography>
                  <Typography variant="body1">{readOnlyData.ver2_assesment_amt || "-"}</Typography>
                </Box>

                <Box>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    Verifier 2 Remarks
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    {readOnlyData.ver_2_remarks || "-"}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    CA Assessment Amount
                  </Typography>
                  <Typography variant="body1">
                    ₹{caVerifiedAmount.toLocaleString()} {caVerifiedAmount === 0 && "(N/A)"}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    CA Remarks
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    {readOnlyData.ca_remark || "-"}
                  </Typography>
                </Box>

                {/* Editable settlement fields with validation */}
                <TextField
                  label="Settlement ID *"
                  name="settle_id"
                  value={formik.values.settle_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  error={formik.touched.settle_id && Boolean(formik.errors.settle_id)}
                  helperText={formik.touched.settle_id && formik.errors.settle_id}
                />

                <TextField
                  label="Settlement Amount *"
                  name="settl_amt"
                  type="number"
                  value={formik.values.settl_amt}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  error={formik.touched.settl_amt && Boolean(formik.errors.settl_amt)}
                  helperText={formik.touched.settl_amt && formik.errors.settl_amt}
                  inputProps={{ step: '0.01', min: '0' }}
                />

                <TextField
                  label="Settlement Remarks"
                  name="sttl_remarks"
                  multiline
                  minRows={3}
                  value={formik.values.sttl_remarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                />
              </Stack>
            </form>
          </Box>

          {/* Footer */}
          <Box sx={{ p: 2, borderTop: "1px solid #ccc", display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button 
              type="submit" 
              form="settle-form"
              variant="contained" 
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Settle Claim
            </Button>
            <Button 
              type="button"
              variant="outlined" 
              onClick={handleCloseEditModal} 
              disabled={formik.isSubmitting}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
